import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Box } from "theme-ui";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Box sx={{
      mb: 4,
      border: t => `1px solid ${t.colors.muted}`,
      borderRadius: 2,
      variant: "styles.pre"
    }} mdxType="Box">
      <p>{`Thanks for supporting Serverless Handbook!
Consider sharing it with friends ❤️`}</p>
      <p>{`Add it to your bookshelf if you haven't.`}</p>
      <p><a parentName="p" {...{
          "href": "https://geni.us/serverless-handbook"
        }}><span parentName="a" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "240px",
              "textAlign": "center",
              "fontStyle": "italic"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "36.32286995515695%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'145\\'%20viewBox=\\'0%200%20400%20145\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M13%2014c-8%203-8%202-8%2059%200%2056%200%2055%207%2059%204%203%20373%203%20378%200%206-4%206-3%206-59%200-57%200-56-8-60-6-2-370-2-375%201m10%2014l-1%209v9h4c6%200%2010-5%207-8-2-1-2-2-1-3%201-3%201-5-1-6-1-2-7-3-8-1m15%205l-1%206c0%206%202%209%206%207h3c2%200%202%200%202-6l-1-7c-1-2-3%202-3%206l-1%205c-2%200-3-2-3-8%200-4-1-5-2-3m13%203l3%207c2%205%202%206-1%206l-2%202c0%201%204%201%206-1l4-14c1-4-2-3-3%202s-1%205-4-2c-1-5-3-5-3%200m38-2c-4%205-1%2013%204%2013%202%200%206-5%206-7%200-6-7-10-10-6m12-1c-1%202%202%2013%204%2013l2-3c0-4%201-4%203%200%200%202%201%203%202%203%202-1%205-12%204-13h-1l-3%205-2-3c-1-3-1-3-3-2l-1%204-1%203-1-2c0-5-2-8-3-5m28%201c-4%204-1%2013%204%2013%202%200%205-4%205-7%200-7-6-10-9-6m13%205l1%207c1%200%202-1%202-5s1-6%202-6c2%200%202%201%202%205%201%207%203%208%204%201%200-7-1-9-6-9l-5%201v6m-26%2021c-6%202-9%206-9%2010%200%203%208%203%2010%200%204-5%2010-3%209%202%200%202-1%203-6%204-10%201-14%205-14%2013%200%209%2011%2014%2018%208%204-2%204-3%206%200%201%203%203%203%206-1%203-3%203-3%202-6-2-2-2-5-2-12l-1-12c-3-6-12-8-19-6m93%200c-7%202-11%206-11%2010%200%203%209%203%209%200%201-2%206-4%208-2l2%204c0%202-1%202-7%203-9%202-13%206-13%2013%200%205%201%208%205%2010%203%202%2010%201%2013-1l3-2%202%202c3%203%204%203%207-1%203-3%203-3%202-5-2-2-2-5-2-13%200-9%200-11-2-13-4-5-11-7-16-5m-52%202c-3%202-3%202-4%201%200-2-2-2-5-2h-4v38h10V85c0-14%201-16%205-16%203%200%203%201%203%2017l1%2013h9V86c0-14%201-17%205-17%203%200%204%202%204%2016l1%2014h3l5-1V66c-3-6-11-8-16-3l-3%203-2-3c-3-4-9-4-12-1m80-1c-2%200-3%205%200%207l6%201c6-1%206-1-4%2013-4%206-5%208-5%2012%200%205%200%205%205%203s13-2%2017%200c5%201%206%201%206-3s-5-8-12-8c-2%200-3-1-1-2l6-9c6-9%207-13%205-14h-23m38%200c-12%205-14%2028-3%2036%2012%208%2025-2%2024-20-1-13-11-20-21-16m38%202c-2%202-2%202-3%200%200-2-1-2-5-2h-4v19l1%2019h9V85c1-13%201-16%205-16%203%200%203%202%204%2016l1%2014h9V68c-2-7-11-11-17-5m44%204c-1%201%200%203%206%208l6%206-6%207c-6%206-7%209-5%209s16-15%2016-16l-8-8c-6-6-8-7-9-6m-80%203c-4%205-2%2022%203%2022%204%200%207-6%206-16-1-8-5-11-9-6m-36%2032c-7%202-7%202%202%203%2010%201%2010%201%204%2016h2c4-4%208-16%206-19h-14m-103%202a87%2087%200%2000105%209c4-3%201-3-7%200-14%204-19%205-33%206-21%201-39-3-57-12l-8-3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/516c68aad10c56a5cd37d14934d41e2f/ca0a1/buy-now-amazon.webp 223w", "/static/516c68aad10c56a5cd37d14934d41e2f/8ac56/buy-now-amazon.webp 240w"],
                "sizes": "(max-width: 240px) 100vw, 240px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/516c68aad10c56a5cd37d14934d41e2f/e92b6/buy-now-amazon.png 223w", "/static/516c68aad10c56a5cd37d14934d41e2f/8ff5a/buy-now-amazon.png 240w"],
                "sizes": "(max-width: 240px) 100vw, 240px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/516c68aad10c56a5cd37d14934d41e2f/8ff5a/buy-now-amazon.png",
                "alt": "buy now amazon",
                "title": "buy now amazon",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span></a></p>
      <p><a parentName="p" {...{
          "href": "https://geni.us/serverless-handbook"
        }}><figure parentName="a" {...{
            "className": "gatsby-resp-image-figure",
            "style": {
              "textAlign": "center",
              "fontStyle": "italic"
            }
          }}>{`
    `}<span parentName="figure" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "890px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "56.05381165919282%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20113v112h115a4911%204911%200%200010-3v-2c-1-1%205-2%2013-2l7%201c-2%202-1%202%205%201h10l6-1%2017-1a1530%201530%200%200074-4c-7%200-18-3-17-6l-1-1%201-2h-1c-3%200-3-1%201-3%202%200%203-1%203-2l-4%201-3%201-1-1-1-1v-1c-1%200%200-2%202-3l4-3-4%202-4%202-6-3-8-3-2-1%201%2013v13h-22v-3a1052%201052%200%2000-1-55v-11l16-10a101%20101%200%200118-10l-1-2c-2-1-7%202-7%203l-1%201h-1l-6%203-8%205-3%202-3%201c-2%203-5%203-5%201l-1-10a2273%202273%200%2000-3-108%201392%201392%200%2001112%201l-7-2c-3%200-4-3-3-3%202-2%201-3-1-3s-3-1-3-2l-2-2%2022-7%2016-4-161-1H0v113M195%203c-9%201-13%203-16%206l-3%203%2021%201a280%20280%200%200130%200c1%202%202%201%204-2l2-4c-3-3-25-6-38-4m-69%2036a11449%2011449%200%20005%20160l1%2017h2c2%200%202%200%202-9a3180%203180%200%2001-9-162c0-11-1-14-1-6M38%2056a391%20391%200%2000-4%2024%20364%20364%200%2000-5%2032%20432%20432%200%2000-6%2036%205829%205829%200%2000-11%2072c0%202%202%202%2014%202%2014%200%2021-1%2017-2-2-1-3-11-3-49a1135%201135%200%2000-2-115m257%2062c-6%202-8%204-8%205l-1%202%204%202%203-3c1-5%205-5%207-1l1%2013c-2%201%205%205%207%205l1-2-1-3h-1c-2%200-2-1-2-7l-2-11v-5l-8%205m-42%2028c-1%203-1%203-5%202l-4%201h-5l-4%201%202%201c2%200%203%202%2014%2013l4%203%201%201v5c-2%201-3%201-5-3-4-5-4-5-4-2%202%207%202%208%200%208-3%200-4-1-5-8%200-6-2-12-4-12l-6%2012-3%201c-2%201-3%201-3%203l1%208v5l6%202c7%204%206%204%2014-1s8-5%208%201c0%204%200%205-2%206-3%201-1%202%202%202l5-5c2-2%203-3%205-3l7-2c3-2%204-2%205-1l2%201c3%200%206%202%206%204s-5%203-9%203l-4-1%201%208v12l1%203h16v-12c0-2%2014-9%2015-9l-9%206c-4%203-4%203-4%208v6h11c29%202%2028%202%2028-1%200-1-1-2-3-2-3%200-6-3-5-6l-1-3v-5c2-3%204-4%204-1h2v-3l2-1c2-1%202%200%202%203s0%203%202%203c1-1%202%200%204%202%202%203%207%203%206%200-1-8-1-9%201-10%202-2%205%202%204%204l-1%208c0%206-2%208-3%205-1-1-6%201-5%203h3l5%201%202%201-1-2c-2-1-1-2%202-2%203-1%203-1%203-4-1-2-1-3%202-6l3-2h-3c-3%201-4%200-4-5l-1-3h-3l-3-2-4%201c-2%202-4%202-4-1l2-1%202-1%202-1%201%201h3c1-1%204-2%205-1l2-1h4c2-1%202-1%200-1-2-1-2-1-1-3%200-4-4-4-6-1-2%205-9%205-9%201%200-2%202-3%204-2l1-1-3-1-3-2c0-2-3-4-3-2h-1l-4-1c-3%200-3%201-3%203s0%202%203%202c2%200%203%200%202%202l-1%203v3l-1%203c-1%202-1%202-3%201h-4c-2%201-2%201-2-8l-1-8-1-4v4l-1%205c-3%200-3%200-4-10l1-8h1l-2-2h-2l3%202h-4c-2%200-3-1-3-2h-1c-2%200-2%200%200-1%201-1%201-1-4-2-4%200-5-1-5-3-1-4-2-3-5%201l-4%205-1%202-3%204-2%203c1%201%2015-8%2015-9l1-2%201%201%201%201%203%201-2%201h-1c3%202%204%203%204%201-1-1%200-1%201-1v18h-3c-3%200-3-1-3-4l-1-4-15%207-14%208c-1-3%200-9%201-10l1-3%202-5%202-3h-2c-2%200-3-1-3-4-1-4-2-4-7-3-3%200-3%200-1%202%202%201%203%203%201%203l-4-2-6-3c-2%200-2-1-2-2l4-1c5%200%205-1%202-4s-6-3-8%200m-47%208c-2%202-2%204-2%207-1%205%202%205%209%200%207-4%207-7%202-8h-5l-4%201m-101%2013c-1%203%202%2041%203%2043l-1-39-2-4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/static/69021b72e882726314125a99b60ce6d9/ca0a1/serverless-handbook-bookshelf.webp 223w", "/static/69021b72e882726314125a99b60ce6d9/75680/serverless-handbook-bookshelf.webp 445w", "/static/69021b72e882726314125a99b60ce6d9/8d1ba/serverless-handbook-bookshelf.webp 890w", "/static/69021b72e882726314125a99b60ce6d9/3838e/serverless-handbook-bookshelf.webp 1335w", "/static/69021b72e882726314125a99b60ce6d9/e11e5/serverless-handbook-bookshelf.webp 1780w", "/static/69021b72e882726314125a99b60ce6d9/0811d/serverless-handbook-bookshelf.webp 6000w"],
                  "sizes": "(max-width: 890px) 100vw, 890px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/static/69021b72e882726314125a99b60ce6d9/853b2/serverless-handbook-bookshelf.jpg 223w", "/static/69021b72e882726314125a99b60ce6d9/0a4fe/serverless-handbook-bookshelf.jpg 445w", "/static/69021b72e882726314125a99b60ce6d9/7f80b/serverless-handbook-bookshelf.jpg 890w", "/static/69021b72e882726314125a99b60ce6d9/dc6ba/serverless-handbook-bookshelf.jpg 1335w", "/static/69021b72e882726314125a99b60ce6d9/2d2e5/serverless-handbook-bookshelf.jpg 1780w", "/static/69021b72e882726314125a99b60ce6d9/857b3/serverless-handbook-bookshelf.jpg 6000w"],
                  "sizes": "(max-width: 890px) 100vw, 890px",
                  "type": "image/jpeg"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/static/69021b72e882726314125a99b60ce6d9/7f80b/serverless-handbook-bookshelf.jpg",
                  "alt": "Serverless Handbook on your bookshelf",
                  "title": "Serverless Handbook on your bookshelf",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
              "className": "gatsby-resp-image-figcaption"
            }}>{`Serverless Handbook on your bookshelf`}</figcaption>{`
  `}</figure></a></p>
      <p>{`Cheers,`}<br />{`
~Swizec`}</p>
    </Box>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      